import { setCookie, getCookie } from '../cookie/cookieHandlers'
const currencyBtns = document?.querySelectorAll('[data-cur-btn]')
const currCurrencyEls = document.querySelectorAll('[data-current-currency]')

function createCurrencyStore() {
  const CURRENCIES = JSON.parse(atob(getCookie('currencies_rates')?.replaceAll('"', '')))

  let selectedCurrencyType = getCookie('selected_currency')
  if (!selectedCurrencyType) {
    selectedCurrencyType = 'eur'
  }

  let listeners = []
  let selectedCurr = CURRENCIES[selectedCurrencyType]

  const getSelectedCurr = () => ({ ...selectedCurr })
  const getAllCurrencies = () => ({ ...CURRENCIES })

  /**
   * @param {'eur'|'gbp'|'rub'|'uah'|'usd'} newCurr - currency 3-char code
   */
  const changeCurrency = newCurr => {
    selectedCurr = CURRENCIES[newCurr]
    setCookie('selected_currency', newCurr, 30)

    switchCurrencyUI(selectedCurr)

    listeners.forEach(listener => {
      listener()
    })
  }

  const subscribe = listener => {
    listeners.push(listener)

    /* unsubscription function */
    // return () => {
    //   listeners = listeners.filter(l => l !== listener)
    // }
  }

  return { getSelectedCurr, getAllCurrencies, changeCurrency, subscribe }
}

export const currencyStore = createCurrencyStore()

function switchCurrencyUI(currencyData) {
  currCurrencyEls.forEach(el => {
    const textEl = el.querySelector('[data-currency-text]')
    textEl.innerHTML = currencyData.symbol + ' ' + currencyData?.currency_type
  })

  currencyBtns.forEach(btn => {
    const curr = btn?.getAttribute('data-cur-btn')
    if (curr === currencyData?.currency_type) {
      btn.classList.add('selected')
    } else {
      btn.classList.remove('selected')
    }
  })
}
